import styles from './styles.module.scss';
import LayoutHeaderNavigation from './Navigation';
import Link from 'next/link';
import { Image } from '@starsoft/common/components';
import LanguageButton from '@/components/Language/Button';
import LayoutHeaderMobileNavigation from './MobileNavigation';
import useHeaderChangeTheme from '@/hooks/useHeaderChangeTheme';
import { useIsMobile } from '@starsoft/common/hooks';

export default function Header() {
  const { headerTheme, logoColor } = useHeaderChangeTheme();
  const isMobile = useIsMobile();

  return (
    <div className={styles.container} data-theme={headerTheme}>
      <div className={styles.container__wrapper}>
        <Link href="/">
          <Image
            className={styles.container__wrapper__logo}
            alt="logo starsoft"
            src={`/starsoft-logo/starsoft-${logoColor}.svg`}
            width={150}
            height={40}
          />
        </Link>
        {isMobile ? null : <LayoutHeaderNavigation />}
        <div className={styles.container__row}>
          <LanguageButton />
          {isMobile ? <LayoutHeaderMobileNavigation /> : null}
        </div>
      </div>
    </div>
  );
}
